export const acceptedFileTypes = ['image/png', 'image/jpg', 'image/jpeg'];
export const MAX_FILE_SIZE = 1054294 * 2;